import { useAccount } from '@/hooks/useAccount';
import { accountDestination } from '@/lib/account-session';
import { Navigate } from 'react-router';

export default function AuthCallback() {
    const { account } = useAccount();
    return <Navigate to={accountDestination(account)} replace />;
}